import React, { useState, useEffect } from "react";
import { ChatOperationProps } from "../Services/CommonServices/propTypes";
import { deleteChatData } from "../Services/ApiServices/chatServices";
import { useDispatch, useSelector } from "react-redux";
import { apiError, conversationList, isStream, historyListArray, userCheck } from "../Services/Redux/Reducers/chatSlice";
import { loader, } from "../Services/Redux/Reducers/commonSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { Cookies } from 'react-cookie-consent';
import { cloneDeep } from "lodash";
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

function ChatOperation(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = props;
  const [show, setShow] = useState(false);
  // debug always visible
  const customerId = Cookies?.get('ar_user_Id') ? Cookies.get('ar_user_Id') : "";
  const historyData = useSelector((state) => state.chat.historyListArray);
  const { t } = useLanguage();

  // Prevent body scroll when modal is open on iOS
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [show]);

  const handleClose = (event) => {
    // Only close if clicking on the backdrop, not on child elements
    if (event && event.target === event.currentTarget) {
      setShow(false);
    }
  }

  const deleteChat = (event) => {
    // Prevent event bubbling and default behavior on iOS
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // Do not close the modal immediately on iOS - wait for successful delete
    storeMessage(data);
  }

  const handleShow = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setShow(true);
  }

  const popUpClose = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setShow(false);
  }
 
  const storeMessage = async (data) => {
    const { sessionId } = data
    const params = {
      customerId,
      sessionId,
      deleteAll: false
    }
    
    // Show loader while deleting
    dispatch(loader(true));
    
    try {
      deleteChatData(params, (response) => { // Chat History storing the messages 
        if (response.status === 200) {
          if (historyData && historyData.data) {
            const deletedItems = historyData.data.filter(item => item.sessionId !== sessionId);
            let convoList = cloneDeep(historyData);
            convoList["data"] = deletedItems;
            dispatch(historyListArray(convoList));
            dispatch(userCheck(true));
          }
          setShow(false);
            try {
              const sp = new URLSearchParams(location.search);
              const hasHistoryParam = sp.get('history') === 'active';
              if (!hasHistoryParam) {
                sp.set('history', 'active');
                const newSearch = `?${sp.toString()}`;
                // Use replace to avoid an extra history entry and to avoid full reloads in webview
                navigate(`/${newSearch}`, { replace: true });
              } else {
                // Re-trigger navigation replace to ensure offcanvas logic runs in parent
                navigate(`${location.pathname}${location.search}`, { replace: true });
              }
            } catch (e) {
              // Fallback: navigate to chathistory with history param
              navigate('/?history=active', { replace: true });
            }
        } else {
          // Non-200 response should be handled here
          dispatch(loader(false));
          const message = response && response.data && response.data.message ? response.data.message : 'Unexpected response';
          dispatch(apiError(message));
        }
      }, (err) => {
        dispatch(apiError(err.message));
        dispatch(loader(false)); 
      });
    } catch (error) {
      dispatch(apiError('Failed to delete chat'));
      dispatch(loader(false));  
    }
  }
 
  const newChat = () => {
    dispatch(isStream(false))
    dispatch(conversationList([]))
    dispatch(loader(false));
    navigate('/chat');
  }
 
  return (
    <div className="addDelete">
      <div className="d-flex justify-content-center align-items-end">
        <div
          className="d-flex justify-content-center align-items-end mb-5"
          style={{ gap: "65px" }}
        >
          <div className="d-flex flex-column  align-items-center">
            <button
              name="newChatButton"
              className="btn btn-custom-white rounded-circle "
              style={{
                padding: "9px 10px",
                borderRadius: "22px",
                backgroundColor: "#041E3A",
                border: "none",
                marginBottom: "10px",
              }}
              onClick={newChat}
            >
              <img
                src="./static/assets/Stepper.svg"
                height="24px"
                width="24px"
                className="button-icon"
                style={{ border: "1px" }}
                alt="img"
                
              />
            </button>
            <span className="button-label">{t('New Chat')}</span>
          </div>
          <div className="d-flex flex-column align-items-center">
            <button
              name="deleteChatButton"
              onClick={handleShow}
              className="btn btn-custom-white rounded-circle "
              style={{
                padding: "9px 10px",
                borderRadius: "22px",
                backgroundColor: "#FFFFFF",
                border: "none",
                marginBottom: "10px",
                
              }}
            >
              <img
                src="./static/assets/Delete.svg"
                className="button-icon"
                height="24px"
                width="24px"
                style={{ border: "1px" }}
                alt="img"
              />
            </button>
            <span className="button-label">{t('DELETE CHAT')}</span>
 
            {show && (
              <div
                id="myModal" role="dialog"
                className="modal d-flex justify-content-center align-items-center"
                tabIndex={-1}
                onClick={handleClose}
                onTouchStart={(e) => e.stopPropagation()}
                style={{ position: 'fixed', zIndex: 9999 }}
              >
                <div className="modal-dialog-main" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content main-content justify-content-center"
                       onTouchStart={(e) => e.stopPropagation()}
                       onTouchEnd={(e) => e.stopPropagation()}>
                    <button
                      name="closeButton"
                      type="button"
                      className="modal-close-icon"
                      aria-label="Close"
                      onClick={popUpClose}
                    ><img src="./static/assets/Close_icon.svg" className="close_icon" /></button>
 
                    <div className="modal-body1 main-body-title">
                      <div className="modal_body_title1">
                        <p>{t('Are you sure you want to delete the chat?')}</p>
                      </div>
                      <div className="modal_body_title2 mt-2">
                        <p>
                          {t('By deleting the chat this message will no longer be available to access.')}
                        </p>
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-center "
                      style={{ width: "100%", padding: "0px 20px" }}
                    >
                      <button
                        name="deleteButton"
                        type="button"
                        className="btn delete-btn me-2"
                        onClick={deleteChat}
                      >
                        {t('DELETE CHAT')}
                      </button>
 
                      <button
                        name="cancelButton"
                        type="button"
                        className="btn cancel-btn"
                        onClick={popUpClose}
                      >
                        {t('CANCEL')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
 
ChatOperation.propTypes = ChatOperationProps;
 
export default ChatOperation;
